(() => {
  const money = (cents, currency) => {
    const locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'SEK',
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency || ''}`.trim();
    }
  };

  const initShopForm = (root) => {
    if (!root || root.dataset.vefReady === 'true') return;
    root.dataset.vefReady = 'true';

    const form = root.querySelector('form[data-vef-product-form]');
    if (!form) return;

    const price = root.querySelector('[data-vef-live-price]');
    const qtyPrices = root.querySelectorAll('[data-vef-qty-price]');
    const variantInputs = [...form.querySelectorAll('input[name="id"]')];
    const qtyInputs = [...form.querySelectorAll('input[name="quantity"]')];
    const currency = root.dataset.currency || 'SEK';
    const discountPercent = Number(root.dataset.duoDiscountPercent || 0);
    const discountCode = root.dataset.duoDiscountCode || '';
    const cartUrl = root.dataset.cartUrl || '/cart';

    const currentVariant = () => variantInputs.find((input) => input.checked) || variantInputs[0];
    const currentQuantity = () => Number((qtyInputs.find((input) => input.checked) || qtyInputs[0])?.value || 1);

    const update = () => {
      const variant = currentVariant();
      if (!variant) return;

      const unit = Number(variant.dataset.price || 0);
      const quantity = currentQuantity();
      let total = unit * quantity;
      if (quantity > 1 && discountPercent > 0 && discountCode) {
        total = Math.round(total * (1 - discountPercent / 100));
      }

      if (price) price.textContent = money(unit, currency);

      qtyPrices.forEach((node) => {
        const q = Number(node.dataset.quantity || 1);
        let qTotal = unit * q;
        if (q > 1 && discountPercent > 0 && discountCode) {
          qTotal = Math.round(qTotal * (1 - discountPercent / 100));
        }
        node.textContent = money(qTotal, currency);
      });

      root.dataset.selectedVariant = variant.value;
      root.dataset.selectedQuantity = String(quantity);
    };

    [...variantInputs, ...qtyInputs].forEach((input) => input.addEventListener('change', update));
    update();

    form.addEventListener('submit', (event) => {
      const variant = currentVariant();
      const quantity = currentQuantity();
      if (!variant || variant.disabled) return;

      if (quantity > 1 && discountCode) {
        event.preventDefault();
        const separator = '?';
        const url = `${cartUrl}/${encodeURIComponent(variant.value)}:${quantity}${separator}discount=${encodeURIComponent(discountCode)}&storefront=true`;
        window.location.assign(url);
      }
    });
  };

  const openCourseFromHash = () => {
    const id = (window.location.hash || '').replace('#', '');
    if (!id) return;
    const target = document.getElementById(id);
    if (target?.tagName === 'DETAILS') target.open = true;
  };


  const initContactTopicFromQuery = () => {
    const select = document.querySelector('[data-vef-contact-topic]');
    if (!select) return;
    const topic = new URLSearchParams(window.location.search).get('topic');
    if (!topic) return;
    const option = [...select.options].find((item) => item.value.toLowerCase() === topic.toLowerCase());
    if (option) select.value = option.value;
  };

  const initCourseEnquiries = () => {
    document.querySelectorAll('[data-vef-course-enquiry]').forEach((link) => {
      link.addEventListener('click', () => {
        const value = link.dataset.vefCourseEnquiry;
        const select = document.querySelector('[data-vef-contact-topic]');
        if (!select || !value) return;
        const option = [...select.options].find((item) => item.value === value);
        if (option) select.value = value;
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-vef-shop-root]').forEach(initShopForm);
    initCourseEnquiries();
    initContactTopicFromQuery();
    openCourseFromHash();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('hashchange', openCourseFromHash);
  document.addEventListener('shopify:section:load', boot);
})();
